import { Component, Input } from '@angular/core';
import { Content } from '../../../../models/search-results';

@Component({
    selector: 'app-course-result',
    templateUrl: './course-result.component.html',
    styleUrls: ['./course-result.component.scss'],
    standalone: false
})
export class CourseResultComponent {
    @Input() course: Content;
}
